import * as yup from 'yup'

import { LoginFields } from './login.types'

export const loginSchema = yup.object().shape({
    [LoginFields.username]: yup.string().required('AUTH.REQUIRED_FIELD'),
    [LoginFields.password]: yup.string().required('AUTH.REQUIRED_FIELD'),
})
